import styled from 'styled-components';
import NumberFormat from 'react-number-format';

const NumberInput = styled(NumberFormat)`

    box-shadow: none;
    border: 0;
    border-radius: 0;
    outline: none;
    -webkit-appearance: none;
    -moz-appearance: none;
    appearance: none;
    width: 100%;
    text-overflow: ellipsis;
    
    &:disabled {
        box-shadow: none;
        border-radius: 0;
        background: none;
        color: #666666;
        -webkit-text-fill-color: #666666;
        opacity: 1; /* required on iOS */
    }

    &:focus {
        outline: none;
    }
      
`;

export default NumberInput;
